export default "__VITE_ASSET__BOFuyE9O__"